module.exports = __webpack_public_path__ + "static/media/parental_cover.7b3f69de.svg";